import { AxiosResponse, AxiosError } from 'axios';

import {
    HarvestEventDocuments,
    HarvestEventDocumentsLoadRequestedAction,
    HarvestEventDocumentsLoadSucceededAction,
    HarvestEventDocumentsLoadFailedAction,
    HarvestEventDocumentsLoadCanceledAction,
    HarvestEventDocumentsSetAction
} from './types';
import {
    HARVEST_EVENT_DOCUMENTS_LOAD_REQUESTED,
    HARVEST_EVENT_DOCUMENTS_LOAD_SUCCEEDED,
    HARVEST_EVENT_DOCUMENTS_LOAD_FAILED,
    HARVEST_EVENT_DOCUMENTS_LOAD_CANCELED,
    HARVEST_EVENT_DOCUMENTS_SET
} from './constants';

/**
 * Intended to be called from a component.
 */
export function requestHarvestEventDocumentsLoad(
    entityId: number
): HarvestEventDocumentsLoadRequestedAction {
    return {
        type: HARVEST_EVENT_DOCUMENTS_LOAD_REQUESTED,
        payload: {
            entityId
        }
    };
}

/**
 * Only intended for use in redux-sagas.
 * @param response
 */
export function succeededLoadHarvestEventDocuments(
    response: AxiosResponse
): HarvestEventDocumentsLoadSucceededAction {
    return {
        type: HARVEST_EVENT_DOCUMENTS_LOAD_SUCCEEDED,
        payload: response
    };
}

/**
 * Only intended for use in redux-sagas.
 * @param error
 */
export function failedLoadHarvestEventDocuments(
    error: AxiosError
): HarvestEventDocumentsLoadFailedAction {
    return {
        type: HARVEST_EVENT_DOCUMENTS_LOAD_FAILED,
        payload: error,
        error: true
    };
}

/**
 * Intended to be called from a component.
 */
export function harvestEventDocumentsLoadCanceled(): HarvestEventDocumentsLoadCanceledAction {
    return {
        type: HARVEST_EVENT_DOCUMENTS_LOAD_CANCELED
    };
}

/**
 * Only intended for use in redux-sagas.
 */
export function setHarvestEventDocuments(
    harvestEventDocuments: HarvestEventDocuments
): HarvestEventDocumentsSetAction {
    return {
        type: HARVEST_EVENT_DOCUMENTS_SET,
        payload: harvestEventDocuments
    };
}
